import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { getAuthSettingsCall, postRefreshTokenCall } from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getAuthSettingsCall.saga,
  postRefreshTokenCall.saga,
];

export function* loginSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
